// @flow
import React, { Component } from 'react';
import Circles from 'components/common/Loaders/Circles';
import CartTemplate from 'components/cart/CartTemplate';
import type { State } from 'store';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { track, TRACKING_EVENTS } from 'lib/tracking';
import { buildItemFromCartItem } from 'lib/tracking/ecommerce';
import { CartActions } from '../../store/actionCreators';
import axios from '../../lib/defaultClient';

type Props = {
  logged: boolean,
  cart: any,
  items: any,
  gradeDiscount: any,
};

class CartTemplateContainer extends Component<Props> {
  state = {
    initLoading: true,
  };

  initialize = async () => {
    this.setState({ initLoading: true });
    try {
      if (this.props.logged) {
        await CartActions.getCart();
      } else {
        await CartActions.getAsNonRegisteredCart({ items: window.CacheBy.LocalCart.items });
      }
      this.trackCartViewed();
      this.setState({ initLoading: false });
    } catch (e) {
      console.log(e);
    }
  };

  trackCartViewed = () => {
    const { cart } = this.props;
    if (!cart || !cart.items) return;
    const items = cart.items.map(buildItemFromCartItem);
    const value = items.reduce((sum, item) => sum + item.value, 0);
    track(TRACKING_EVENTS.CART_VIEWED, { items, value });
  };

  getCartItemTrackingData = (item: any) => {
    return buildItemFromCartItem(item);
  };

  componentDidMount() {
    this.initialize();
  }

  // 전체 체크
  allCheckedCart() {
    CartActions.allCheckedCart();
  }

  // 한개 체크
  updateCheckedCart(index) {
    CartActions.updateCheckedCart(index);
  }

  // 수량 변경
  updateItemCart = async (index, itemId, payload) => {
    if (this.props.logged) {
      await CartActions.updateItemCart(index, itemId, {
        quantity: Number(payload.target.value),
      });
    } else {
      await CartActions.updateItemAsNonRegisteredCart({
        index,
        itemId,
        quantity: Number(payload.target.value),
      });
    }
  };

  // 전체상품 삭제
  emptyCart = async () => {
    const { cart } = this.props;
    const trackingItems = cart && cart.items ? cart.items.map(this.getCartItemTrackingData) : [];
    if (this.props.logged) {
      await CartActions.emptyCart();
    } else {
      await CartActions.emptyAsNonRegisteredCart();
    }
    if (trackingItems.length > 0) {
      const totalValue = trackingItems.reduce((sum, item) => sum + (item.value || 0), 0);
      track(TRACKING_EVENTS.PRODUCT_CART_REMOVED, { items: trackingItems, value: totalValue });
    }
  };

  // 선택상품 삭제
  deleteItemCheckedCart = async () => {
    const { cart } = this.props;
    if (cart.items.length) {
      const checkedItems = cart.items
        .filter(item => item.checked === true)
        .map(item => ({
          itemId: item.id,
          trackingData: this.getCartItemTrackingData(item),
        }));
      const deletedTrackingItems = [];
      for (let index = 0; index < checkedItems.length; index += 1) {
        const { itemId, trackingData } = checkedItems[index];
        try {
          if (this.props.logged) {
            // eslint-disable-next-line no-await-in-loop
            await CartActions.deleteItemCart(itemId);
          } else {
            CartActions.deleteItemAsNonRegisteredCart({ itemId });
          }
          deletedTrackingItems.push(trackingData);
        } catch (e) {
          console.error('deleteItemCart error:', e);
        }
      }
      if (deletedTrackingItems.length > 0) {
        const totalValue = deletedTrackingItems.reduce((sum, item) => sum + (item.value || 0), 0);
        track(TRACKING_EVENTS.PRODUCT_CART_REMOVED, { items: deletedTrackingItems, value: totalValue });
      }
    }
  };

  // 단일상품 삭제
  deleteItemCart = async itemId => {
    const item = this.props.cart.items.find(i => i.id === itemId);
    const trackingData = item ? this.getCartItemTrackingData(item) : null;
    if (this.props.logged) {
      await CartActions.deleteItemCart(itemId);
    } else {
      CartActions.deleteItemAsNonRegisteredCart({ itemId });
    }
    if (trackingData) {
      track(TRACKING_EVENTS.PRODUCT_CART_REMOVED, trackingData);
    }
  };

  onOffer = () => {
    if (this.props.cart.items.filter(item => item.checked === true).length) {
      this.props.history.push('/offer');
    } else {
      alert('상품을 선택 해주세요.');
    }
  };

  onShopping = () => {
    this.props.history.push('/');
  };

  onOrder = () => {
    if (this.props.cart.items.filter(item => item.checked === true).length) {
      this.props.history.push('/checkout');
    } else {
      alert('상품을 선택 해주세요.');
    }
  };

  goProduct = async id => {
    if (!id) return;
    try {
      const result = await axios.get(`/products/url/${id}`);
      this.props.history.push(result.data);
    } catch (e) {
      console.error('goProduct error:', e);
    }
  };

  render() {
    if (this.state.initLoading) return <Circles color="blue" size="medium" text="Loading..." />;

    return (
      <CartTemplate
        cart={this.props.cart}
        items={this.props.cart.items}
        goProduct={this.goProduct}
        allCheckedCart={this.allCheckedCart}
        updateCheckedCart={this.updateCheckedCart}
        updateItemCart={this.updateItemCart}
        emptyCart={this.emptyCart}
        deleteItemCheckedCart={this.deleteItemCheckedCart}
        deleteItemCart={this.deleteItemCart}
        removeSelectedCart={this.deleteItemCheckedCart}
        removeAllCart={this.emptyCart}
        onOffer={this.onOffer}
        onShopping={this.onShopping}
        onOrder={this.onOrder}
        gradeDiscount={this.props.gradeDiscount}
      />
    );
  }
}

export default connect(
  ({ cart, user, pender }: State) => ({
    cart,
    items: cart.items,
    logged: !!user.user,
    loading: pender.pending['cart/GET_CART'],
    loading1: pender.pending['cart/GET_AS_NON_REGISTERED_CART'],
    gradeDiscount: (user.user && user.user.grade.value) || 0,
  }),
  () => ({}),
)(withRouter(CartTemplateContainer));



// WEBPACK FOOTER //
// ./src/containers/cart/CartTemplateContainer.js